import { render, staticRenderFns } from "./healthManage.vue?vue&type=template&id=987e8ff6&scoped=true&"
import script from "./healthManage.vue?vue&type=script&lang=js&"
export * from "./healthManage.vue?vue&type=script&lang=js&"
import style0 from "./healthManage.vue?vue&type=style&index=0&id=987e8ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987e8ff6",
  null
  
)

export default component.exports